import { o as otto } from "../chunks/nexus-client-client-TGyNJoMo.mjs";
const benefit = otto.benefit;
export {
  benefit
};
/*                                     */
